import { TinyUser } from '../../../types/userProfile';
import Avatar from '../../images/avatar';
import { HStack } from '../../layouts/stack.layout';
import MessageGroupList from '../../lists/message-group.list';
import Container from '../container';

type MessageContainerProps = {
  user: TinyUser;
  owned: boolean;
  messages: string[];
};

export default function MessageContainer({
  user,
  messages,
  owned,
}: MessageContainerProps) {
  return (
    <HStack extensions="w-full" gap="sm" rowReverse={owned ? true : false}>
      <Container extensions="self-end">
        <Avatar size="2xs" url={user.avatarUrl} alt={user.username} />
      </Container>
      <MessageGroupList messages={messages} owned={owned} />
    </HStack>
  );
}
